import { Vue, Component, Prop } from 'vue-property-decorator';
import { TableCellData, TableCellObject } from 'components';
import FeatureVersionValidator from '@/components/feature-version-validator/feature-version-validator.vue';

@Component({
	components: {
		'feature-version-validator': FeatureVersionValidator
	}
})
export default class PropsTableCellBody extends Vue {
	@Prop({
		default() {
			return {
				cell: {
					text: ''
				}
			};
		}
	})
	data!: TableCellData;

	getCellClass(cell: TableCellObject) {
		return cell.colType ? PropsTableCellBody.colTypeClasses[cell.colType] : '';
	}

	static colTypeClasses: {
		[index: string]: {};
	} = {
		propName: 'color_highlight-4',
		type: 'color_highlight-8'
	};
}
